// mediaStore.js  ← new file, import this wherever needed
export const mediaStore = new Map();
// key: item.ind + question.ind  →  value: { url, blob, dataUrl, etc }